<template>
  <b-dropdown class="dropdown-form" v-bind:class="{'color-button': (!defaultValue)}">
    <template slot="button-content">
      <i class="fas fa-bath"></i> Baths: {{ getBathNumber }}<span v-if="!defaultValue">+</span>
      <reset-button v-if="!defaultValue" v-on:x-button-clicked="resetBathNumber"></reset-button>
    </template>
    <b-dropdown-item v-for="bath in baths" v-bind:key="bath" v-on:click="updateBathNumber(bath)">{{ bath }}<span v-if="bath !== 'Any'">+</span></b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import defaultValues from '../../../../../store/lib/defaultValues.js'
import ResetButton from '../../../../general/buttons/CircleEnclosedXButton.vue'

export default {
  data () {
    return {
      baths: ['Any', '1', '2', '3', '4', '5']
    }
  },
  components: {
    ResetButton
  },
  methods: {
    ...mapMutations('homeSearch', [
      'updateBathNumber'
    ]),
    resetBathNumber () {
      this.updateBathNumber(defaultValues.bathNumber)
    }
  },
  computed: {
    ...mapGetters('homeSearch', [
      'getBathNumber'
    ]),
    defaultValue () {
      return this.getBathNumber === defaultValues.bathNumber
    }
  }
}
</script>

<style scoped>
.dropdown-form >>> .dropdown-item {
  color: #4f4f4f !important;
}

.color-button >>> .btn {
  background-color: #eaeaea !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/searchBar/buttons/Baths.vue